export const VERSION_RETRY_PARAM = 'version_retry'
export const REFRESH_RETRY_PARAM = 'refresh'
export const VERSION_CHECK_EXPIRY_MS = 30 * 1000

export const isChunkLoadError = (error) =>
  error?.name === 'ChunkLoadError' ||
  error?.message?.includes('Failed to fetch dynamically imported module') ||
  // Firefox words the same failure differently
  error?.message?.includes('error loading dynamically imported module') ||
  error?.message?.includes('Importing a module script failed') ||
  error?.message?.includes('Unable to preload CSS')

export const handleChunkLoadError = (error) => {
  if (!isChunkLoadError(error)) {
    throw error
  }

  const now = Date.now()
  const url = new URL(window.location.href)
  const lastAttemptStr = url.searchParams.get(REFRESH_RETRY_PARAM)

  if (lastAttemptStr) {
    const lastAttempt = parseInt(lastAttemptStr, 10)
    if (now - lastAttempt < VERSION_CHECK_EXPIRY_MS) {
      console.warn('[Chunk Load] Reload attempted too recently, showing error instead')
      return
    }
  }

  console.warn('[Chunk Load] Triggering reload:', error)
  url.searchParams.set(REFRESH_RETRY_PARAM, now.toString())
  window.location.href = url.toString()
}

export const handleVersionMismatchReload = () => {
  const now = Date.now()
  const url = new URL(window.location.href)
  const lastAttemptStr = url.searchParams.get(VERSION_RETRY_PARAM)

  if (lastAttemptStr) {
    const lastAttempt = parseInt(lastAttemptStr, 10)
    if (now - lastAttempt < VERSION_CHECK_EXPIRY_MS) {
      console.warn('[Version Check] Reload attempted too recently, skipping to prevent loop')
      return
    }
  }

  url.searchParams.set(VERSION_RETRY_PARAM, now.toString())
  window.location.href = url.toString()
}

export const cleanRetryParams = () => {
  const url = new URL(window.location.href)
  if (url.searchParams.has(REFRESH_RETRY_PARAM) || url.searchParams.has(VERSION_RETRY_PARAM)) {
    url.searchParams.delete(REFRESH_RETRY_PARAM)
    url.searchParams.delete(VERSION_RETRY_PARAM)
    window.history.replaceState({}, '', url.toString())
  }
}
